import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SettingsService } from '../../providers/settings.service';
import { InnerSection, Section, SectionAttributes } from '../../types/section';
import { LinkSection } from '../../types/link';
import { CommonModule } from '@angular/common';
import { ExtendedFooterComponent, FooterAddressComponent, FooterIconLinkComponent, FooterIconLinkSectionComponent, FooterLinkSectionComponent } from '@knorr-bremse-portals/ngx-components/components/footer-extended';
import { iconFacebook, iconInstagram, iconLinkedin, iconTwitter, iconXing, iconYoutube } from '@knorr-bremse-portals/icons';
import { ProgressIndicatorComponent } from '@knorr-bremse-portals/ngx-components/components/progress-indicator';
import { HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { FooterLinkComponent, FooterComponent as KBFooterComponent } from '@knorr-bremse-portals/ngx-components/components/footer';
import { EditorIdDirective } from '../../directives/editor-id.directive';

const iconMap = {
  'facebook': iconFacebook,
  'instagram': iconInstagram,
  'linkedin': iconLinkedin,
  'twitter': iconTwitter,
  'xing': iconXing,
  'youtube': iconYoutube,
} as const;

interface SocialMediaLinkAttributes extends SectionAttributes {
  url: string;
  icon: keyof typeof iconMap;
}
type SocialMediaLinkSection = InnerSection<SocialMediaLinkAttributes, [], 'social-media-link'>;

interface FooterAttributes extends SectionAttributes {
  contactHeadline: string;
  contact: string;
  links: LinkSection[];
  quickLinks: LinkSection[];
  socialMediaLinks: SocialMediaLinkSection[];
}

type FooterEditorIds = [
  'contactHeadline',
  'contact',
];

export type FooterSection = Section<FooterAttributes, FooterEditorIds, 'footer'>;

@Component({
    selector: 'app-footer',
    styleUrls: ['./footer.component.scss'],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule, ProgressIndicatorComponent, HtmlComponent,
        KBFooterComponent,
        FooterLinkComponent,
        FooterLinkSectionComponent,
        ExtendedFooterComponent,
        FooterIconLinkComponent,
        FooterIconLinkSectionComponent,
        FooterAddressComponent,
        EditorIdDirective,
    ],
})
export class FooterComponent {

  private settingsService = inject(SettingsService);
  protected data$ = this.settingsService.footer;
  protected iconMap = iconMap;

}
